import script from "./date-range.vue?vue&type=script&setup=true&lang=js"
export * from "./date-range.vue?vue&type=script&setup=true&lang=js"

import "./date-range.vue?vue&type=style&index=0&id=535e205d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535e205d"]])

export default __exports__